export default __webpack_public_path__ + "static/media/181.8d8456e7.jpg";